export default { 
  setData(state, { payload }) {
    state.allData = payload.data.list;
  },

  clearData(state) {
    state.allData = [];
    state.totalData = 0;
  },
  setItem(state, { payload }) {
    state.item = payload.data;
  },

  setStateVariable(state, { payload, variable }) {
    state[variable] = payload;
  },
  setFlashErrorMessage(state, payload) {
    state.flashErrorMessage = payload;
    state.flashError = payload != '';
  },

  clearErrors(state) {
    state.errors = [];
  },

  setErrors(state, payload) {
    state.errors = payload;
  },

  setTotalData(state, { payload }) {
    state.totalData = parseInt(payload.data.countdata, 10);
    state.totalPage = parseInt(payload.data.totalPage, 10);
  },

  setLoading(state, loading) {
    state.loading = loading;
  },

  setIntervalExport(state, payload) {
    state.intervalExport = payload;
  },

  setExportData(state, payload) {
    state.exportId = payload.export_id;
    state.countDataExport = payload.count_data;
  },

  setCancelation(state, payload) {
    state.requestData = payload;
  },

  setDataPromo(state, payload) {
    state.data = payload;
  },

  setDataVariable(state, { payload, variable }) {
    state.data[variable] = payload;
  },
  clearDataVariable(state) {
    state.data.id = null;
    state.data.old_promo_type = '';
    state.data.promo_type = '';
    state.data.merchants = [];
    state.data.bulk_id = '';
    state.data.promo_name = '';
    state.data.qr_method_npm = false;
    state.data.qr_method_cpm = false;
    state.data.payment_type_on_us = false;
    state.data.payment_type_off_us = false;
    state.data.min_transaction = '';
    state.data.promo_period = [];
    state.data.promo_quota_per_merchant = '';
    state.data.promo_quota_per_customer = '';
    state.data.promo_quota_merchant_per_day = '';
    state.data.promo_quota_customer_per_day = '';
    state.data.jenis_promo = '';
    state.data.discount_type = '';
    state.data.percent = '';
    state.data.max_discount_amount = '';
    state.data.fix_amount = '';
    state.data.syarat_dan_ketentuan = '';
    state.data.bulk_upload_status = 0;
    state.data.status = 1;
    state.data.disabled_form = false;
    state.data.disabled_edit = false;
  },
  clearDataStep(state) {
    state.step = 1;
    state.data.promo_type = '';
  },

  setStep(state, step) {
    state.step = step;
  },

  setFinishStep(state, payload) {
    state.finishStep = payload;
  },

  setDataMerchant(state, { payload }) {
    state.merchantList = payload.data.list;
  },
  clearDataMerchant(state) {
    state.merchantList = [];
  },

  setOnUpload(state, onUpload) {
    state.onUpload = onUpload;
  },
  clearLastResult(state) {
    state.countData = 0;
    state.onUpload = false;
  },

  setDataMerchantPromo(state, { payload }) {
    state.allDataMerchantPromo = payload.data.list;
  },

  clearDataMerchantPromo(state) {
    state.allDataMerchantPromo = [];
    state.totalDataMerchantPromo = 0;
  },

  setTotalDataMerchantPromo(state, { payload }) {
    state.totalDataMerchantPromo = parseInt(payload.data.countdata, 10);
    state.totalPageMerchantPromo = parseInt(payload.data.totalPage, 10);
  },
};